// @flow

import type {TreeStructure} from '@pb/kit-component-tree-v2';

export const flattenTreeByIdsList = (data: TreeStructure, checkedIdsList: Array<string>, caption?: string = ''): {
    updatedCheckedIdsList: Array<string>,
    updatedData: TreeStructure,
} => {
    let updatedCheckedIdsList = [];
    let updatedData = [];
    data.forEach(currentData => {
        const currentChildren = currentData.children;
        let currentCaption = currentData.caption || '';
        currentCaption = caption + (caption.length ? ' > ' : '') + currentCaption;
        if (currentChildren) {
            const flattened = flattenTreeByIdsList(currentChildren, checkedIdsList, currentCaption);
            updatedCheckedIdsList = updatedCheckedIdsList.concat(flattened.updatedCheckedIdsList);
            updatedData = updatedData.concat(flattened.updatedData);
        } else if (checkedIdsList.includes(currentData.id)) {
            updatedCheckedIdsList.push(currentData.id);
            updatedData.push({...currentData, caption: currentCaption, alwaysExpanded: true});
        }
    });
    return {updatedCheckedIdsList, updatedData};
};
